import React, { useEffect, useState } from "react";
import Typewriter from "typewriter-effect";
import Social from "../Social/Social";
import "./Intro.css";

const Intro = ({ introData }) => {
  return (
    <div className="container">
      <div className="row intro">
        <div className="col-md-6">
          <div className="d-flex align-items-center h-100 intro-left">
            <div class="mobile-margin visible-xs"></div>
            <div>
              <h1 className="intro-description">
                Hi, I am <span style={{ color: "#0bc2c2" }}>Roky Das</span>
              </h1>
              <h4>
                <Typewriter
                  options={{
                    strings: introData.designation,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </h4>
              {<p>{introData.description}</p>}
              <Social />
              <a
                href="https://www.linkedin.com/in/roky-das-448b3617b/"
                target="_blank"
              >
                <button className="custom-btn mr-3">Hire Me</button>
              </a>
              <a
                href="https://drive.google.com/u/0/uc?id=1CgI-MBkWILCNSxn4MrJ_EQjRnhFz0sar"
                target="_blank"
              >
                <button className="custom-btn">Resume</button>
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-6 d-flex justify-content-center">
          <div className="intro-img w-75">
            <img className="img-fluid text-center" src={introData.img} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
